import { stringify } from 'querystring';
import { get, post } from './client';

export function getAllGrowers() {
  return get(`/growers?${stringify({ inc_inactive: true })}`);
}

export function getManageableOperations() {
  return get(`/operations`);
}

export function getGrowersAssignable(username) {
  return get(`/growers/users/${username}`);
}

export function saveGrower(grower) {
  return post('/growers/save', grower);
}

export function getFieldsByGrower(growerId) {
  return get(`/fields/certified/by-grower/${growerId}`);
}
